import e from "react";
var s = e.createContext({
  activeFlyout: null,
  setActiveFlyout: function setActiveFlyout() {},
  isBreakpointWithMenu: !1,
  isTouch: !1,
  scrollbarWidth: 0,
  flyoutAnimation: "",
  menuData: null,
  isAnimating: !1,
  setIsAnimating: function setIsAnimating() {},
  isSubmenuOpen: !1,
  setIsSubmenuOpen: function setIsSubmenuOpen() {},
  isDesktopMenuOpen: !1,
  setIsDesktopMenuOpen: function setIsDesktopMenuOpen() {},
  isUserActionsMenuOpen: !1,
  setIsUserActionsMenuOpen: function setIsUserActionsMenuOpen() {},
  authenticatedUser: null,
  isAuthLoading: !1,
  handleFlyoutOpen: function handleFlyoutOpen() {},
  handleFlyoutClose: function handleFlyoutClose() {},
  loginAction: function loginAction() {},
  logoutAction: function logoutAction() {}
});
export { s as PrimaryNavContext };